export default __webpack_public_path__ + "static/media/profile-user-white.ccbe117b.svg";